import request from '../request'

//兑换优惠券
export const couponsCreate = (cv_account_token,data)=>{
	return request({
		url: `/v3/cv_accounts/${cv_account_token}/invitations`,
		method: 'POST',
		data
	})
}

//udesk在线客服链接
export const udeskOnlineUrl = (params) => {
	return request({
		url: '/v3/cv_accounts/udesk_settings',
		method: 'GET',
		params
	})
}


//获取头像、昵称、求职邮箱
export const getUsersBasicInfo = (cv_account_token, params) => {
	return request({
		url:`/v3/cv_accounts/${cv_account_token}/basic_info`,
		method: 'GET',
		params
	})
}

//更新头像、昵称、真实姓名
export const updateUsersBasicInfo = (cv_account_token, data) => {
	return request({
		url: `/v3/cv_accounts/${cv_account_token}/basic_info`,
		method: 'PUT',
		data
	})
}

// 帐号安全设置（微信、手机、邮箱）
export const getUsersSettings = cv_account_token => {
	return request({
		url: `/v3/cv_accounts/${ cv_account_token }/security_settings`,
		method: 'GET',
		params: {}
	})
}
/*
  * 获取邮箱/手机号验证码
  * email	 邮箱地址
  * phone_number 手机号码
  * way	获取验证码方式 email/phone
  * confirm	yes
*/
// export const getValidateCode = (data) => {
// 	return request({
// 		url: '/v1/get_validate_code',
// 		method: 'POST',
// 		data
// 	})
// }
/*
  * 绑定邮箱
  * email	邮箱地址
  * email_token	验证码
  *
  * 设置邮箱密码
  * email 邮箱地址
  * current_password	当前密码
  * password	新密码
  * password_confirmation	确认密码
  *
  * 绑定手机号码
  * phone	手机号码
  * phone_token	验证码
*/
// export const updateInfo = (data) => {
// 	return request({
// 		url: '/v1/account/users/update_info',
// 		method: 'POST',
// 		data
// 	})
// }

/*
  * 解绑手机
*/
// export const unbindPhone = (data) => {
// 	return request({
// 		url: '/v1/account/users/unbind_phone',
// 		method: 'POST',
// 		data
// 	})
// }
/*
  * 解绑微信
*/
// export const unbindWechat = (data) => {
// 	return request({
// 		url: '/v1/account/users/unbind_wechat',
// 		method: 'POST',
// 		data
// 	})
// }

// 获取订单列表
export const getOrdersData = (token, params) => {
	return request({
		url: `/v3/cv_accounts/${ token }/orders`,
    method: 'GET',
    params
	})
}
// 取消订单
export const cancelOrder = (cv_token,token, params) => {
	return request({
		url: `/v3/cv_accounts/${ cv_token }/orders/${token}`,
    method: 'DELETE',
    params
	})
}

// 订单详情
export const getOrderAlert = (cv_token, token, params) => {
	return request({
		url: `/v3/cv_accounts/${ cv_token }/orders/${token}`,
    method: 'GET',
    params
	})
}




//  创建新的超级会员定单
export const createOrder = (data) => {
  return request({
    url: '/v3/orders/improved_orders',
    method: 'POST',
    data
  })
}
//  更新的超级会员定单  member_period
export const updateOrder = (token, data) => {
  return request({
    url: `/v3/orders/improved_orders/${token}`,
    method: 'PUT',
    data
  })
}
//获取订单详情
export const  getOrderDetail = (cv_token,token,params) => {
  return request({
		url: `/v3/cv_accounts/${cv_token}/orders/${token}`,
		method: 'GET',
		params
  })
}

//创建预付订单
export const  orderPay = (token,data)=>{
  return request({
    url: `/v3/orders/improved_orders/${token}/pay`,
    method: 'POST',
    data
  })
}

//获取优惠券
export const  getSpecialOffers = (cv_account_token,params)=>{
  return request({
    url: `/v3/cv_accounts/${cv_account_token}/special_offers`,
    method: 'GET',
	  params
  })
}

//检查订单状态
export const checkOrder = (token,params)=>{
	return request({
		url:`/v3/orders/check/${token}`,
		method: 'GET',
		params
	})
}
//优惠活动邀请
export const getInvite = (cv_account_token,params)=>{
	return request({
		url:`/v3/cv_accounts/${cv_account_token}/special_offers`,
		method: 'GET',
		params
	})
}
//导师辅导购买页面验证码
export const getVeriCode = (cv_account_token,params)=>{
	return request({
		url:`/v3/cv_accounts/${cv_account_token}/phone_validate_code`,
		method: 'GET',
		params
	})
}

//验证验证码
export const verifyCode = (cv_account_token,params)=>{
	return request({
		url:`/v3/cv_accounts/${cv_account_token}/phone_validate_code`,
		method: 'POST',
		params
	})
}
//更新手机号
export const updatePhone = (cv_account_token,params,method)=>{
	return request({
		url:`/v3/cv_accounts/${cv_account_token}/basic_info`,
		method: method,
		params
	})
}
// 获取阿里云oss配置
export const getOssConfig = params => {
	return request({
		url: '/v3/file_upload_token',
		method: 'GET',
		params
	})
}
// 问题反馈提交
export const feedbackSubmit = data => {
	return request({
		url: (process.env.NODE_ENV == 'development' ? '/adminapi' : process.env.ADMIN) + `/admin/v1/feedbacks`,
		method: 'POST',
		data
	})
}

// 获取隐私设置
export const getPersonPrivacy = cv_account_token => {
	return request({
		url: `/v3/cv_accounts/${cv_account_token}/privacy`,
		method: 'GET'
	})
}

// 设置隐私设置
export const setPersonPrivacy = (cv_account_token, data) => {
	return request({
		url: `/v3/cv_accounts/${cv_account_token}/privacy`,
		method: 'POST',
		data
	})
}

/***
 * 绑定手机号时获取简历手机号自动填充
 * ***/
export const getUserCvPhone = cv_account_token => {
	return request({
		url: `/v3/cv_accounts/${cv_account_token}/cv_phone`,
		method: 'GET'
  })
}

/***
 * 检测用户是否关注公众号
 * ***/
export const getUserCvPublic = cv_account_token => {
	return request({
		url: `/v3/cv_accounts/${cv_account_token}`,
		method: 'GET'
  })
}

/***
 * 获取用户信息
 * ***/
export const getUserInfos = cv_account_token => {
	return request({
		url: `/v3/cv_accounts/${cv_account_token}`,
		method: 'GET'
  })
}

/***
 * 获取落地页信息
 * ***/
 export const getLandingPageData = params => {
	return request({
		url: `/v3/landing_pages/message`,
		method: 'GET',
    params
  })
}

// 获取当前用户的教育经历是否有机构号
export const getUserGroups = () => {
	return request({
		url: '/v3/groups_user/get_groups',
		method: 'GET'
	})
}

// 裂变页入口
export const getUserEntrance= (params) => {
	return request({
		url: '/v3/groups_user/groups_entrance',
		method: 'GET',
    params
	})
}

// 账号注销获取该用户下的信息
export const beforeUserChancel= (params) => {
	return request({
		url: '/v3/auth/cancellation_check',
		method: 'GET',
    params
	})
}

// 账号注销
export const logout = params => {
  return request({
		url: '/v3/auth/cancellation',
		method: 'POST',
    data: params
	})
}


// 创建纠错订单
// plan : plan find_error_once / find_error_ten_times
export const createFindErrorOrder = data => {
	return request({
    url: '/v3/orders/find_error_orders',
    method: 'POST',
    data
  })
}

// 用户最近半年是否购买过月度会员
export const isHalfYearMember= () => {
	return request({
		url: '/v3/improved_orders/purchase_record',
		method: 'GET'
	})
}

// 获取会员权益
export const getAgreementCount= (cv_account_token) => {
	return request({
		url: `/v3/cv_accounts/${cv_account_token}/agreement_count`,
		method: 'GET'
	})
}

// 获取设备列表
export const getDeviceList = (params) => {
  return request({
    url: `/v3/auth/trusted_devices`,
    method: 'GET',
    params
  })
}

const HOST = process.env.VUE_APP_EVN === 'production' ? 'https://api.wondercv.com' : 'https://api.wondercv.cn'

export const getCip = () => {
	return request({
		url: `${HOST}/health/cip?format=json`,
		method: 'GET'
	})
}

export const fetchMemberRightsList = (params) => {
	return request({
		url: `/v3/improved_orders/member_rights`,
		method: 'GET',
		params
	})
}

// 兑换腾讯视频会员
export const convertTencentVideoMember = (data) => {
	return request({
		url: '/v3/improved_orders/tecent_video',
		method: 'POST',
		data
	})
}

export const fetchAccountUnionMembers = (token, params) => {
	return request({
		url: `/v3/cv_accounts/${token}/union_members`,
		method: "GET",
		params
	})
}

/**
 * 查看账户是否锁定
 */

export const checkUserLock = () => {
	return request({
		url: '/v3/check_user_available',
		method: 'GET',
	})
}

/**
 * 查看简历是否使用 vip 样式
 */
export const checkUseVip = (token, params) => {
	return request({
		url: `/v3/cvs/${token}/check_use_vip`,
		method: 'GET',
		params
	})
}

/**
 * 领取优惠券
 */
export const receiveUniMemberCode = (token, id) => {
	return request({
		url: `/v3/improved_orders/union_member_code/${token}/${id}`,
		method: 'POST'
	})
}

export const updateUserBonus = (token) => {
	return request({
		url: `/v3/cv_accounts/${token}/bonus`,
		method: 'PUT'
	})
}
